<template>
  <Drawer
    width="400"
    :title="`${openedSupplier ? '编辑' : '新增'}供应商`"
    v-model="drawerOpened"
  >
    <div class="drawer-content">
      <Form
        @submit.native.prevent
        ref="formItem"
        :model="formItem"
        :rules="ruleValidate"
        label-position="top"
      >
        <FormItem label="供应商" prop="name" style="width: 366px">
          <Input
            v-model="formItem.name"
            clearable
            placeholder="请填写供应商名"
          />
        </FormItem>
        <FormItem label="供应商简称" prop="abbr" style="width: 366px">
          <Input
            v-model="formItem.abbr"
            clearable
            placeholder="请填写供应商简称"
          />
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit('formItem')">保存</Button>
        </FormItem>
      </Form>
    </div>
  </Drawer>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "EditSupplierDrawer",
  data() {
    return {
      drawerOpened: false,
      formItem: {
        name: null,
        abbr: null,
      },
      openedSupplier: null,
      ruleValidate: {
        name: [
          { required: true, message: "供应商为必填项", trigger: "submit" },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.currentUser,
    }),
  },
  methods: {
    ...mapActions({
      createSupplier: "supplier/createSupplierAction",
      updateSupplier: "supplier/updateSupplierAction",
    }),
    async openDrawer(supplier) {
      this.$refs["formItem"].resetFields();
      this.openedSupplier = supplier; // 如果有打开，则为编辑模式
      if (supplier) {
        this.formItem.name = supplier.name;
        this.formItem.abbr = supplier.abbr;
      }
      this.drawerOpened = true;
    },
    handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          try {
            if (this.openedSupplier) {
              await this.updateSupplier({
                id: this.openedSupplier._id,
                data: this.formItem,
              });
            } else {
              await this.createSupplier(this.formItem);
            }
            this.$Message.success("保存成功!");
            this.drawerOpened = false;
          } catch (error) {
            this.$Message.error(`失败: ${error}`);
          }
        } else {
          this.$Message.error("保存失败!");
        }
      });
    },
  },
};
</script>
<style lang="stylus" scoped></style>